import { Injectable, EventEmitter } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import {Subject} from 'rxjs/Subject';

import { environment } from '../../../environments/environment';
import { User } from './authentication.model';
import { Auth0Service } from '../../common/services/auth0/auth0.service';
import { LocalstorageService } from '../../common/services/localstorage/localstorage.service';
import { preferenceDefaultMenu  } from '../../../assets/data/defaults';
import { preferenceDefaultDashboard  } from '../../../assets/data/defaults';


@Injectable()
export class AuthenticationService {
  _user: User;
  idToken: string;
  accessToken : string;
  token : string;
  headers: HttpHeaders = new HttpHeaders();
  authenticationChanged: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router , private http: HttpClient,
              private auth0Service: Auth0Service, private localstorage: LocalstorageService) {
    this.loadUser();
  }

  /* USER */
  /** get User from localStorage */
  loadUser() {
    let user = this.localstorage.getToken('user') || new User();
    let expire: number = Number(this.localstorage.getItem('expires_at'));
    let token: string = this.localstorage.getItem('token');
    if (expire){
      const notexpired =  (new Date().getTime() < expire);
      console.log (notexpired, new Date().getTime(), expire, token)
      if (notexpired){
        this.accessToken = token;
        this.token = token;
        this.headers = this.headers.set('Authorization', 'Bearer ' + this.accessToken);
        document.querySelector('body').classList.toggle('sidebar-hidden');
      }
      else {
        this.localstorage.removeToken('token');
        this.localstorage.removeToken('user');
        localStorage.clear();
        this.currentUser = null;
        user = new User();
      }
    }
    this.currentUser = new User(user);
    this.checkSession()
    .mergeMap(registerResp => this.userInfo())
    //.mergeMap(tenantResp => this.getTenant())
    // .mergeMap(registerResp => this.getIdentity())
    .subscribe(result => {
      if (!this.isLogged) {
        this.router.navigateByUrl('');
      } else if (location.href !== location.origin) {
        this.router.navigateByUrl('/dashboard');
      }
    }, error => {
      if (!this.isLogged) {
        this.router.navigateByUrl('');
      }
    });
  }

  /**Get Current User */
  get currentUser(): User {
    return this._user;
  }

  /**Set Current User */
  set currentUser(value) {
    this._user = new User(value);
  }

  /*AUTHETICATION */


  saveToken(authResult,connection) {
    const expiresIn = authResult.expiresIn || authResult.expires_in;
    const expiresAt = expiresIn * 1000 + new Date().getTime();


      console.log(authResult.id_token)
      this.idToken = authResult.id_token;
      this.accessToken = authResult.access_token;
      this.token = authResult.access_token;
      this.localstorage.setToken('idToken', this.idToken);
      this.localstorage.setToken('token', this.accessToken);
      this.localstorage.setToken('expires_at', expiresAt);
      localStorage.setItem('idToken', this.idToken);
      localStorage.setItem('token', this.accessToken);
      localStorage.setItem('expires_at', expiresAt.toString());
      this.headers = this.headers.set('Authorization', 'Bearer ' + this.accessToken);

  }

  /** Register User */
  register(data: any): Observable<any> {
    return this.http.post(environment.API + '/registration', JSON.stringify(data), {headers: this.headers});
  }

  /** Set Payment Method Info */
  setPaymentMethod(data: any): Observable<any> {
    return this.http.post(environment.API + '/api/payment', JSON.stringify(data), {headers: this.headers});
  }

  /** LogOut User */
  logout() {
    this.localstorage.removeToken('token');
    this.localstorage.removeToken('user');
    localStorage.clear();
    this.currentUser = null;
    this.auth0Service.logout();
    this.authenticationChanged.emit();
  }

  /** return is User Logged */
  get isLogged() {
    const expiresAt = this.localstorage.getItem('expires_at');
    const notexpired =  (new Date().getTime() < expiresAt);
    return this.currentUser && this.currentUser.authenticated && notexpired;
  }

  get user_email() {

    return this.currentUser

  }

  /** Get User Info */
  getIdentity() {
    return this.http.get(environment.API + '/api/identity', {headers: this.headers})
    .map(response => {
      this.currentUser.identity = response;
      this.localstorage.setToken('user', this.currentUser);
      return response;
    });
  }


  signup(user): Observable<any> {
    return this.auth0Service.signup(user);
  }

  login(connection, email?, password?) {
    const that = this;
    switch (connection) {
      case 'Username-Password-Authentication':
        return this.auth0Service.authorize(email, password)
          .map(authResult => {
            if (authResult) {
              console.log('Token Saved')
              that.saveToken(authResult,connection);
            }
            return authResult;
          });
      case 'google-oauth2':
      case 'windowslive':
        return this.auth0Service.authorize_social(connection)
        .map(authResult => {
          if (authResult) {
            that.saveToken(authResult,connection);
          }
          return authResult;
        });
    }
  }

  checkSession() {
    const that = this;
    return this.auth0Service.checkSession()
    .map(authResult => {
      if (authResult) {
        that.saveToken(authResult,"Username-Password-Authentication");
      }
      return authResult;
    });
  }

  userInfo() {
    const that = this;

    return this.auth0Service.userInfo(this.accessToken)
    .map(user => {
      if (user) {
        console.log(user)
        that.currentUser = new User(user);
        that.currentUser.id = user.sub;
        that.currentUser.authenticated = true;
        that.authenticationChanged.emit();
        that.localstorage.setToken('user', that.currentUser);
      }
      return user;
    });
  }

  backRegister(email,first,last,license){

    const data = {
      user_email: email,
      user_uuid: this.currentUser.id,
      license: license,
      user_first_name: first,
      user_last_name: last,
      preference_default_menu: preferenceDefaultMenu,
      preference_default_dashboard: preferenceDefaultDashboard,
    };

    return this.http.post(environment.API + '/registration/',data, {headers: this.headers});

  }

  /*getTenant(){

    const that = this;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.token);

    return this.http.post(environment.API + '/user/tenant/', {user_uuid: this.currentUser.id}, {headers: headers})
    .map((response: any)=> {
      that.currentUser.authenticated = true;
      that.currentUser.tenant_id = response.tenant_id;
      return response;
    })

  }*/

  changePassword(email) {
    return this.auth0Service.changePassword(email);
  }

  allowRegister(data) : Observable<any>   {

    return this.http.post(environment.API + '/license/',data,{headers: this.headers});

  }

  public getUserMenu(): Observable<any>  {
    return this.http.get(environment.API + '/user/menu/', { headers: this.headers });
  }

  public acceptContract(): Observable<any>  {
    return this.http.get(environment.API + '/contract-accepted/', {headers: this.headers});
  }


  
}



// WEBPACK FOOTER //
// ./src/app/views/authentication/authentication.service.ts